<div class="saq-question">
    <div class="saq-question__content" [style.maxWidth.px]="contentMaxWidth">
        <h2 class="saq-question__title">{{ sectionTitle }}</h2>
        <p class="saq-question__note">
            <i><strong>Note:</strong> The following requirements mirror the requirements in the</i>
            PCI DSS Requirements and Testing Procedures <i>document.</i>
        </p>
        <h2 class="saq-question__subtitle">{{ sectionDetails.section_category }}</h2>
        <div class="saq-question__req-row">
            <h2 class="saq-question__req" [innerHTML]="sectionDetails.section_requirement"></h2>
            <ng-container *ngIf="hasAssignedQa; else finalQaTaskStatus">
                <p class="saq-question__status">
                    Assessor Review Status:
                    <span class="saq-question__status-indicator" [ngClass]="qsaReviewStatusClass">
                        {{ qsaReviewStatusLabel }}
                    </span>
                </p>
                <p class="saq-question__status">
                    QA Review Status:
                    <span class="saq-question__status-indicator" [ngClass]="complianceStatusClass">
                        {{ complianceStatusLabel }}
                    </span>
                </p>
            </ng-container>
            <ng-template #finalQaTaskStatus>
                <p class="saq-question__status">
                    Task Status:
                    <span class="saq-question__status-indicator" [ngClass]="complianceStatusClass">
                        {{ complianceStatusLabel }}
                    </span>
                </p>
            </ng-template>
        </div>
        <table class="saq-question__table saq-question__table--main">
            <thead appSaqTableHeader></thead>
            <tbody>
                <tr
                    appSaqSectionSubtitleHeader
                    [sectionId]="sectionId"
                    [sectionKey]="sectionKey"
                    [formType]="formType"
                ></tr>
                <tr class="question__row">
                    <td class="saq-question__cell saq-question__cell--id">{{ sectionDetails.section_number }}</td>
                    <td class="saq-question__cell saq-question__cell--description">
                        <span [innerHTML]="sectionDetails.section_description"></span>
                        <div class="clear"></div>
                        <div class="vertical_10"></div>
                        <ng *ngIf="hasApplicabilityNotes">
                            <div class="section-question__cell--applicability-header">Applicability Notes</div>
                            <div class="saq-question__applicability-notes" [innerHTML]="sectionDetails.applicability_notes"></div>
                        </ng>
                    </td>
                    <td class="saq-question__cell saq-question__cell--testing">
                        <span [innerHTML]="sectionDetails.section_testing"></span>
                    </td>
                    <td class="saq-question__cell saq-question__cell--responses" colspan="5">
                        <table class="saq-question__responses-table">
                            <tbody>
                                <tr
                                    appSaqSection2bCheckboxes
                                    [selectedOption]="selectedOption"
                                    [disabled]="isInteractionDisabled"
                                    [disableNotTestedOption]="disableNotTestedOption"
                                    (selectedOptionChange)="onSelectedOptionChange($event)"
                                ></tr>
                            </tbody>
                        </table>
                        <div class="section-2b__not-tested-note" *ngIf="disableNotTestedOption && formType">
                            Note: {{ formType }} assessments do not allow selecting "Not Tested".
                        </div>
                    </td>
                </tr>
                <tr
                    appSaqResultsDescriptionFooter
                    [resultsDescription]="resultsDescription"
                    [isSaving]="isSaving"
                    [isDisabled]="isInteractionDisabled"
                    [readOnlyUser]="readOnlyLicenseViewer"
                    [isSaveDisabled]="!hasSelectedOption"
                    [isDescriptionRequired]="isResultsDescriptionRequired"
                    [isFormComplete]="isFormComplete"
                    [lastSavedAt]="lastSavedAt"
                    [lastSavedByName]="lastSavedByName"
                    [validationError]="resultsDescriptionError"
                    [activeComplianceStatus]="activeComplianceStatus"
                    [hasAssignedQa]="hasAssignedQa"
                    [isCurrentUserAssignedQa]="isCurrentUserAssignedQa"
                    [qsaReviewedInput]="qsaReviewedInput"
                    [isMarkingNeedsReview]="isMarkingNeedsReview"
                    [isNeedsReviewDisabled]="isNeedsReviewDisabled"
                    (resultsDescriptionChange)="onResultsDescriptionChange($event)"
                    [followUpLink]="followUpLink"
                    (followUpLinkActivated)="onFollowUpLinkActivated($event)"
                    (saveRequested)="onSaveRequested()"
                    (saveDraftRequested)="onSaveRequested('draft')"
                    (needsReviewRequested)="openNeedsReviewModal()"
                ></tr>
            </tbody>
        </table>
    </div>
    <table class="saq-question__table saq-question__table--footers saq-question__table--saq-footers">
        <tbody>
            <tr class="saq-question__footer-row">
                <td
                    appSaqSupportingDocumentationFooter
                    class="saq-question__footer-cell"
                    [sectionId]="sectionId"
                    [sectionKey]="sectionKey"
                    [readOnlyUser]="readOnlyLicenseViewer"
                ></td>
                <td
                    appTaskAssignmentsFooter
                    class="saq-question__footer-cell"
                    [productLicenseId]="activeProductLicenseId"
                    [sectionKey]="sectionId"
                    [requirementKey]="sectionKey"
                ></td>
            </tr>
            <tr class="saq-question__footer-row">
                <td
                    appSaqAssessorNotesFooter
                    class="saq-question__footer-cell"
                    [sectionId]="sectionId"
                    [sectionKey]="sectionKey"
                    [readOnlyUser]="readOnlyLicenseViewer"
                ></td>
                <td
                    appSaqRecentActivityFooter
                    class="saq-question__footer-cell"
                    [sectionId]="sectionId"
                    [sectionKey]="sectionKey"
                    [readOnlyUser]="readOnlyLicenseViewer"
                ></td>
            </tr>
        </tbody>
    </table>
</div>
